export default function Textarea({ label, error, id, rows = 5, className = "", ...props }) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={id} className="text-base font-medium text-slate-700">
          {label}
        </label>
      )}
      <textarea
        id={id}
        rows={rows}
        className={`w-full px-4 py-3 rounded-lg border text-base text-slate-800 bg-white transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent resize-none placeholder:text-slate-400 ${
          error ? "border-red-400" : "border-gray-200"
        } ${className}`}
        {...props}
      />
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}
